import { QCNamingConvention } from './qc-naming-convention';

export class QCProductionMasterNamingConvention extends QCNamingConvention {

  get description(): string {
    return "Production Master";
  }

  get generatedName(): string {
    let name = this.foreignEpisode + '_' + this.format + '_' + this.standard + '_' + this.aspectRatio + '_' + this.programTitle;
    if (this.revision != null) {
      name += '_R' + this.revision
    }
    return name;
  }

  static get requiredComponents(): string[] {
    return [
      'aspectRatio',
      'foreignEpisode',
      'format',
      'programTitle',
      'standard'
    ];
  }

}


// WEBPACK FOOTER //
// ./src/app/qc/qc-naming-conventions/qc-production-master-naming-convention.ts